import { AccessToken, Auth, Message, Password } from "../../domain/model/Auth";
import {
  FilterTrucksByModel,
  GenerateXmlFileResponse,
  Truck,
} from "../../domain/model/Truck";
import { ApiService } from "../api/ApiService";
import { Response } from "../api/Response";
import { API_ENDPOINTS } from "../constant/ApiConstants";
import NetworkApi from "./NetworkApi";

export default class NetworkApiImpl implements NetworkApi {
  apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }
  // auth
  login(auth: Auth): Promise<Response<AccessToken>> {
    return this.apiService.post<AccessToken>(API_ENDPOINTS.LOGIN, auth);
  }
  changePassword(password: Password): Promise<Response<Message>> {
    return this.apiService.post<Message>(
      API_ENDPOINTS.CHANGE_PASSWORD,
      password
    );
  }

  // trucks
  getAllTrucks(
    skip?: number,
    limit?: number,
    filterTrucksByModel?: FilterTrucksByModel
  ): Promise<Response<Array<Truck>>> {
    var url = `${API_ENDPOINTS.TRUCKS}`;
    if (limit !== undefined) {
      url += `?limit=${limit}`;
      if (skip !== undefined) {
        url += `&skip=${skip}`;
      }
    }
    if (filterTrucksByModel != undefined) {
      if (filterTrucksByModel.name != undefined) {
        url += `&truckName=${filterTrucksByModel.name}`;
      }

      if (filterTrucksByModel.rangeDate != undefined) {
        url += `&truckStartDate=${filterTrucksByModel.rangeDate.startDate}&truckEndDate=${filterTrucksByModel.rangeDate.endDate}`;
      }
    }
    return this.apiService.get<Array<Truck>>(url);
  }
  generateXmlFile(
    ids: Array<string>
  ): Promise<Response<GenerateXmlFileResponse>> {
    return this.apiService.post<GenerateXmlFileResponse>(
      API_ENDPOINTS.TRUCKS + API_ENDPOINTS.GENERATE_XML_FILE,
      ids
    );
  }
}
